<template>
  <div>
    <!-- causing Error in updated hook: "TypeError: Cannot read property 'id' of undefined" -->
    <!-- i dont know why - yet -->
    <MembershipModal />

    <div v-if="notFound" class="container">
      <div class="notification is-danger has-text-centered u-p2 has-text-light has-text-weight-semibold" role="alert"
        aria-live="assertive">
        <b-icon icon="exclamation-circle" size="is-large"></b-icon>
        <p class="is-size-4">{{ $t('product.offer-not-found') }}</p>
        <div class="columns">
          <p class="column is-6-fullhd is-offset-3-fullhd is-8-desktop is-offset-2-desktop">
            {{ $t('product.offer-not-found-message') }}
          </p>
        </div>
        <p class="mb-5">
          <a :href="`tel:${$whitelabel.supportMail}`" v-if="$whitelabel.supportPhone">
            <b-icon icon="phone" size="is-small" custom-class="fa-flip-horizontal"></b-icon>
            &nbsp;&nbsp;{{ $whitelabel.supportPhone }}
          </a>
          <br />
          <a :href="`mailto:${$whitelabel.supportMail}`" v-if="$whitelabel.supportMail">
            <b-icon icon="envelope" size="is-small"></b-icon>
            &nbsp;&nbsp;{{ $whitelabel.supportMail }}
          </a>
        </p>
        <div class="buttons u-is-hcenter">
          <b-button type="is-light" tag="router-link" to="/" outlined>{{ $t('general.to-homepage') }}</b-button>
          <b-button type="is-light" tag="router-link" :to="{ name: 'search' }" outlined>{{ $t('general.to-search')
          }}</b-button>
        </div>
      </div>
      <OfferBlock :title="$t('general.further-offers')" :offers="furtherOffers" />
    </div>

    <LoadingPlaceholder :show="!notFound && (!template || !template.id)" />
    <div v-if="!notFound && template && template.id" id="content-start">
      <section class="section" id="hotel-main" v-observe-visibility="{
        callback: handleVariantDisplay,
        intersection: {
          rootMargin: '10%',
        },
      }"
        v-bind:class="{ 'outside-viewport': !isVariantVisible, 'outside-viewport--standalone': $whitelabel.isStandalone && !isVariantVisible }"
        ref="hotelMain" :style="{ height: hotelMainHeight }">
        <div class="container">
          <b-button tag="router-link" to="/" type="is-ghost" icon-left="chevron-left" class="button--back mb-4"
            v-if="$whitelabel.hasBackToOverviewBtn">
            {{ $t('general.to-overview-sr') }}
          </b-button>

          <div class="columns is-variable is-multiline">
            <div class="column is-two-fifths-desktop is-offset-0-desktop is-6-tablet is-offset-3-tablet is-12-mobile">
              <figure class="image hotel-image" @click="scrollToSlider" aria-hidden="true">
                <figcaption v-if="$options.filters.haspromotion(template, 'TravelDeal')"
                  class="deal-headline title has-text-centered u-w100 u-p1 is-size-5 is-size-4-tablet">
                  <span class="is-uppercase is-inline-block">{{ $whitelabel.dealName ? $whitelabel.dealName :
                    $t('product.deal') }}</span>
                </figcaption>

                <picture>
                  <source
                    :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=400&height=400&gravity=smart&quality=50&interlace=true&type=auto&file=${template.image}`"
                    media="(max-width: 480px)" />
                  <source
                    :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=500&gravity=smart&quality=50&interlace=true&type=auto&file=${template.image}`"
                    media="(max-width: 768px)" />
                  <source
                    :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&interlace=true&type=auto&file=${template.image}`"
                    media="(max-width: 1023px)" />
                  <source
                    :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=350&quality=50&interlace=true&type=auto&file=${template.image}`"
                    media="(max-width: 1215px)" />
                  <source
                    :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=440&quality=50&interlace=true&type=auto&file=${template.image}`"
                    media="(max-width: 1407px)" />
                  <source
                    :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=520&quality=50&interlace=true&type=auto&file=${template.image}`"
                    media="(min-width: 1408px)" />
                  <img
                    :src="`https://assets.urlaubsgutschein.kaufen/i/resize?width=720&quality=50&interlace=true&type=auto&file=${template.image}`"
                    :alt="template.subtitle" fetchpriority="high" width="720" height="720" />
                </picture>

                <!-- <Badge v-if="$options.filters.haspromotion(template, 'InsuranceIncluded')" :text="`Gutschein<br>Garantie`" :color="['rgba(253, 216, 53, 1)', 'rgba(249, 168, 37, 1)']" class="offer__badge" /> -->
                <!-- <Badge v-if="this.$whitelabel.short.toLowerCase() === 'greenstorm'" :text="`Geld-zurück<br>Garantie`" :color="['rgba(133, 176, 19, 1)', 'rgba(133, 176, 19, 1)']" class="offer__badge  c-badge--greenstorm" /> -->
              </figure>

              <!-- <div class="deal-countdown--offer has-background-primary-light u-w100rel--mobile" v-if="$options.filters.haspromotion(template, 'TravelDeal')"> -->
              <div class="deal-countdown--offer has-background-primary-light u-w100rel--mobile"
                v-if="$options.filters.hasanypromotion(template) && hasAnyActivePromotion">
                <p class="has-text-centered is-size-4-tablet">
                  {{ $whitelabel.dealCountdownTitle ? $whitelabel.dealCountdownTitle : $t('product.deal-ends') }}
                </p>
                <CountdownTimer v-if="dealEndtime" :endTime="this.dealEndtime"
                  class="has-text-centered deal-countdown__timer" />
              </div>
            </div>
            <div class="column is-half-desktop is-12-touch">
              <OfferTags :offer="template" class="mb-2"></OfferTags>
              <h1 class="title is-size-4-mobile">{{ template.title }}</h1>
              <h2 class="subtitle mb-5 is-size-6-mobile">
                <router-link class="has-text-grey-dark"
                  :to="{ name: 'hotel-overview', params: { contact: template.contact.slug } }">
                  {{ template.subtitle }}
                </router-link>
              </h2>
              <BoardNightsPersonsOverview :variants="variants" />

              <!-- <HotelReminder :hotelid="template.contact.idSstOfferContact"></HotelReminder> -->

              <div class="variant-backdrop" v-bind:class="{ 'is-open': variantsOpen }"></div>
              <div class="variant-container" ref="variantContainer" v-bind:class="{ 'is-open': variantsOpen }">
                <div tabindex="0"
                  class="variant-header columns is-marginless is-mobile has-background-primary is-align-items-center"
                  @click="variantsOpen = !variantsOpen" @keydown.enter="variantsOpen = !variantsOpen">
                  <p class="column has-text-weight-semibold variant-header-text is-size-6-mobile is-size-5 is-10">{{
                    $t('product.choose-offer') }}:</p>
                  <p class="column has-text-right variant-icon-wrapper"><b-icon icon="plus" size="is-medium"
                      class="variant-icon"> </b-icon></p>
                </div>
                <div class="variants">
                  <VariantDisplay v-for="variant in variants" :key="variant.id" :variant="variant"
                    :services="template.services" @variantToCart="closeVariants" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section has-background-white is-medium hotel-content">
        <div class="container">
          <!-- <GreenstormMoneyBack v-if="$whitelabel.short.toLowerCase() === 'greenstorm'" class="mb-6" /> -->

          <Banners v-if="$whitelabel.campaignsEnabled" />

          <div class="columns">
            <div class="column is-8 is-offset-2 is-fullwidth-print">
              <h2 class="title is-size-4-mobile">{{ $t('product.scope') }}</h2>
              <div class="content">
                <span class="has-text-weight-bold">{{ roomCategories }}</span>
                <div v-html="compiledMarkdown"></div>
              </div>
              <!-- <InsuranceInfo v-if="$options.filters.haspromotion(template, 'InsuranceIncluded')" /> -->

              <Validity :validity="template.validity" />
            </div>
          </div>
        </div>
      </section>

      <div id="slider" class="py-6 is-hidden-print">
        <section class="hero is-primary is-clipped slider-wrapper" v-observe-visibility="sliderVisibilityChanged">
          <div class="hero-body slider-body" v-if="isSliderLoaded">
            <Slider v-if="staticStorage && staticStorage.images" :images="staticStorage.images" />
            <content-placeholders v-if="!(staticStorage && staticStorage.images)">
              <content-placeholders-img />
            </content-placeholders>
          </div>
        </section>
      </div>

      <!-- <section class="section">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2 is-fullwidth-print">
              <Gallery v-if="staticStorage && staticStorage.images" :images="staticStorage.images"></Gallery>
            </div>
          </div>
        </div>
      </section> -->

      <section id="slider-after" class="section has-background-white hotel-content content"
        v-observe-visibility="contentVisibilityChanged">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2 is-fullwidth-print">
              <HotelInfo :contacts="template.contacts" />
              <TemplateText :text="staticStorage && staticStorage.texts" />
              <content-placeholders v-if="!staticStorage || !staticStorage.texts">
                <content-placeholders-heading />
                <content-placeholders-text :lines="5" />
              </content-placeholders>
              <HotelFeatures v-show="staticStorage.contactFeatures.length > 0"
                v-if="staticStorage && staticStorage.contactFeatures" :features="staticStorage.contactFeatures" />
              <content-placeholders v-if="!staticStorage || !staticStorage.contactFeatures">
                <content-placeholders-heading />
              </content-placeholders>
              <Separator />
              <RegionInfo v-if="staticStorage && staticStorage.regionTexts" :text="staticStorage.regionTexts" />
              <content-placeholders v-if="!staticStorage || !staticStorage.regionTexts">
                <content-placeholders-heading />
                <content-placeholders-text :lines="5" />
              </content-placeholders>
            </div>
          </div>
          <div class="column is-8 is-offset-2 is-fullwidth-print">
            <GoogleMaps v-if="isContentVisible && template.contacts.length > 0 && template.contact.geoCoordinate"
              :latitude="template.contact.geoCoordinate.latitude" :longitude="template.contact.geoCoordinate.longitude"
              :contact="template.contact" />
          </div>
          <div class="column is-8 is-offset-2 is-fullwidth-print">
            <span v-if="isHoxami">
              {{ $t('product.responsible-hotel') }}<br />
              <button class="button is-text px-0" @click="isVendorAgbModalActive = true">
                <strong>{{ $t('payment.consent.agb_accept_2') }}</strong>
              </button>
            </span>
            <span v-if="!isHoxami">
              {{ $t('product.responsible-agent') }}:<br />

              <button class="button is-text px-0" @click="isVendorAgbModalActive = true">
                <strong>{{ template.vendor.name }}</strong>
              </button>
            </span>

            <b-modal :active.sync="isVendorAgbModalActive" scroll="keep">
              <div class="card">
                <div class="card-content content" v-html="vendorAGB"></div>
              </div>
            </b-modal>
          </div>
        </div>
      </section>
      <OfferBlock :title="$t('general.further-offers')" :offers="furtherOffers" v-if="isContentVisible" />
    </div>

    <RichSnippet :data="template"></RichSnippet>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../_store'
import VariantDisplay from '../_components/VariantDisplay'
import HotelInfo from '../_components/HotelInfo'
import HotelFeatures from '../_components/HotelFeatures'
import TemplateText from '../_components/TemplateText'
import RegionInfo from '../_components/RegionInfo'
import Validity from '../_components/Validity'
import Separator from '@/components/Separator'
import LoadingPlaceholder from '../_components/LoadingPlaceholder'
import BoardNightsPersonsOverview from '../_components/BoardNightsPersonsOverview'
//import InsuranceInfo from '../_components/InsuranceInfo'
import axios from 'axios'
import CountdownTimer from '@/components/CountdownTimer'
import promotion from '@/common/promotion'
import OfferTags from '@/components/Offertags'

//layzload components
const GoogleMaps = () => import(/* webpackPrefetch: true , webpackChunkName: "googlemaps" */ '../_components/GoogleMaps')
const OfferBlock = () => import(/* webpackPrefetch: true , webpackChunkName: "offerblock" */ '@/components/OfferBlock')
const MembershipModal = () => import(/* webpackChunkName: "membershipmodal" */ '@/components/Modals/MembershipModal')
const Slider = () => import(/* webpackPrefetch: true , webpackChunkName: "slider" */ '../_components/Slider')
//const Badge = () => import(/* webpackChunkName: "badge" */ '@/components/Badge')
// const GreenstormMoneyBack = () => import(/* webpackChunkName: "greenstormmoneyback" */ '@/components/Banner/Greenstorm/GreenstormMoneyBack')
const Banners = () => import(/* webpackChunkName: "banners" */ '@/components/Banner/_Banners')
const RichSnippet = () => import(/* webpackChunkName: "richsnippet" */ '../_components/RichSnippet')
// const Gallery = () => import(/* webpackPrefetch: true , webpackChunkName: "gallery" */ '../_components/Gallery')
// const HotelReminder = () => import(/* webpackChunkName: "hotelreminder" */ '@/components/HotelReminder')

export default {
  name: 'OfferView',
  components: {
    VariantDisplay,
    Slider,
    HotelInfo,
    HotelFeatures,
    TemplateText,
    RegionInfo,
    Validity,
    Separator,
    OfferBlock,
    GoogleMaps,
    LoadingPlaceholder,
    BoardNightsPersonsOverview,
    MembershipModal,
    // GreenstormMoneyBack,
    //Badge,
    //InsuranceInfo,
    CountdownTimer,
    Banners,
    RichSnippet,
    // Gallery,
    OfferTags,
    // HotelReminder,
  },
  data() {
    return {
      vendorAGB: '',
      isVendorAgbModalActive: false,
      isSliderLoaded: false,
      dealEndtime: null,
      isContentVisible: false,
      variantsOpen: false,
      isVariantVisible: true,
      roomCategories: '',
      hotelMainHeight: '',
      hasTraveldealTag: false,
      hasAnyActivePromotion: false,
    }
  },
  computed: {
    ...mapGetters({
      variants: '$_hotel/variants',
      template: '$_hotel/template',
      notFound: '$_hotel/notFound',
      furtherOffers: '$_hotel/furtherOffers',
      staticStorage: '$_hotel/staticStorage',
      locale: 'locale',
    }),
    compiledMarkdown: function () {
      // eslint-disable-next-line
      return marked(this.template.services, { sanitize: true })
    },
    id() {
      if (this.$route.params) {
        return this.$route.params.id
      }
      return null
    },
    slug() {
      return this.$route.params.slug
    },
    isHoxami() {
      let vendorId = this.template.vendor.id
      return vendorId == 32 || vendorId == 33
    },

    preloadLinks() {
      if (!this.template || !this.template.image) return [];

      return [
        { rel: 'preconnect', href: '//maps.googleapis.com', crossorigin: 'anonymous' },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=400&height=400&gravity=smart&quality=50&interlace=true&type=auto&file=${this.template.image}`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(max-width: 480px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=500&height=500&gravity=smart&quality=50&interlace=true&type=auto&file=${this.template.image}`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 481px) and (max-width: 768px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/resize?width=500&quality=50&interlace=true&type=auto&file=${this.template.image}`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 769px) and (max-width: 1023px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/resize?width=350&quality=50&interlace=true&type=auto&file=${this.template.image}`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1024px) and (max-width: 1215px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/resize?width=440&quality=50&interlace=true&type=auto&file=${this.template.image}`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1216px) and (max-width: 1407px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/resize?width=520&quality=50&interlace=true&type=auto&file=${this.template?.image}`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1408px)',
        },
        // {
        //   rel: 'preload',
        //   href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=400&height=400&gravity=smart&quality=50&interlace=true&type=auto&file=${hotelImage}`,
        //   crossorigin: 'anonymous',
        //   as: 'image',
        //   media: '(max-width: 480px)',
        // },
      ]
    }
  },
  created() {
    const STORE_KEY = '$_hotel'
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store)
    }
    this.isSliderLoaded = false
  },
  async mounted() {
    await this.loadContent()

    this.$meta().refresh();


    this.hasTraveldealTag =
      this.$whitelabel.campaignsEnabled &&
      (this.$options.filters.haspromotion(this.template, 'Custom:italia') ||
        this.$options.filters.haspromotion(this.template, 'Custom:watitalia') ||
        this.$options.filters.haspromotion(this.template, 'Custom:de22') ||
        this.$options.filters.haspromotion(this.template, 'Custom:gardasee') ||
        this.$options.filters.haspromotion(this.template, 'Custom:suedtirol'))
  },
  watch: {
    async id(newId) {
      if (newId) {
        await this.loadContent()
      }
    },
    async slug(newSlug) {
      if (newSlug) {
        await this.loadContent()
      }
    },
  },
  methods: {
    async loadContent() {
      this.hotelMainHeight = ''

      await this.$store.dispatch('$_hotel/getOffer', {
        id: this.id,
        slug: this.slug,
      })
      await this.$store.dispatch('$_hotel/getOfferData', {
        id: this.template.id,
      })
      //this.isSliderLoaded = true

      // if (promotion.hasActivePromotion('TravelDeal', this.template)) {
      //   const cdDate = promotion.getEndDateForPromotion('TravelDeal', this.template)
      //   if (cdDate) {
      //     this.dealEndtime = cdDate - new Date()
      //   }
      // }

      // deal countdown für promotions
      if (promotion.hasAnyPromotion(this.template)) {
        const cdDate = promotion.getFirstEnddateOfPromotions(this.template.promotions)

        if (cdDate) {
          this.dealEndtime = cdDate - new Date()
        }
      }

      this.hasAnyActivePromotion = promotion.hasAnyActivePromotion(this.template.promotions)

      this.$store.dispatch('$_hotel/getFurtherOffers')

      if (!this.notFound) {
        this.fetchVendorAGB(this.template.vendor.id)
      }

      this.$scrollTo('#hotel-main', 500, {
        offset: -160,
      })
      this.isSliderLoaded = false

      this.getRoomCategories()
    },
    async fetchVendorAGB(vendorId) {
      let vendorName = ''

      console.log('fetching vendor AGB for vendorId:', vendorId);

      switch (vendorId) {
        case 32:
          vendorName = 'hoxami'
          break
        case 33:
          vendorName = 'hoxami_gh'
          break
        case 35:
          vendorName = 'hoxami_sui'
          break
        case 1:
          vendorName = 'sst'
          break
        case 4:
          vendorName = 'bestcase'
          break
      }
      let { data } = await axios.get(`https://assets.urlaubsgutschein.kaufen/static/agb/${vendorName}_${this.$i18n.locale}.md`)

      // eslint-disable-next-line
      this.vendorAGB = marked(data, { sanitize: true })
    },
    contentVisibilityChanged(isVisible) {
      if (isVisible) {
        this.isContentVisible = true
      }
    },
    sliderVisibilityChanged(isVisible) {
      if (isVisible) {
        this.isSliderLoaded = true
      }
    },
    handleVariantDisplay(isVisible) {
      this.isVariantVisible = isVisible
    },
    closeVariants(isOpen) {
      this.variantsOpen = isOpen
    },
    scrollToSlider() {
      this.hotelMainHeight = this.$refs.hotelMain.clientHeight + 'px'

      this.$scrollTo('#slider', 500, { offset: -200, lazy: false })
    },
    getRoomCategories() {
      let uniqueCategories = new Set(
        this.template.variants.map(variant => {
          return variant.room.name
        }),
      )

      this.roomCategories = [...uniqueCategories].join(', ')
    },
  },
  metaInfo() {
    const hotelName = this.template.subtitle
    const hotelDescription = this.template.title
    //const hotelImage = this.template.image

    return {
      title: hotelName,
      meta: [{ name: 'description', content: hotelDescription }],
      link: this.preloadLinks,
    }
  },
}
</script>

<style lang="scss">
.hotel-image {
  position: sticky;
  top: 2em;
  cursor: pointer;
  z-index: 1;

  img {
    aspect-ratio: 1 / 1;
  }

  @media print {
    position: relative !important;
  }
}

.deal-headline {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 1;
  top: 2rem;
  width: 100%;
}

.deal-countdown--offer {
  padding: 1rem;
  position: relative;
  z-index: 2;
}

.offer__badge {
  position: absolute;
  left: 1.5rem;
  bottom: 1.5rem;
}

#hotel-main:not(.outside-viewport) {
  .variant-header {
    background-color: transparent !important;
  }

  .variant-icon-wrapper {
    display: none;
  }
}

.variant-header-text {
  letter-spacing: -0.5px;
}

.outside-viewport {
  .variant-container {
    z-index: 31; //overlay navigation and underlay cart
    // width: 94%;
    // left: 3%;
    width: 100%;
    left: 0;
    //transform: translateY(calc(100% - 3.5rem));
    transform: translateY(100%) translateY(-3.5rem); //2 y-values to support ie11
    //transform: translateY(100%);
    //opacity: 0;
    bottom: 0;
    bottom: env(safe-area-inset-bottom, 0px);
    position: fixed;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
    transition: transform 300ms cubic-bezier(0.37, 0, 0.63, 1);
    animation-name: variantUp;
    animation-duration: 500ms;
    animation-delay: 500ms;
    animation-iteration-count: 1;
    animation-fill-mode: backwards; //get style values of first keyframe
    //animation-direction: alternate;

    .variant-icon {
      //transform: rotate(45deg);
      transition: transform 300ms ease-in-out;
      transition-delay: 350ms;
    }

    &.is-open {
      transform: translateY(0);
      max-height: 100%;
      overflow-y: scroll;
      overflow-x: hidden;

      @media screen and (min-width: 1024px) {
        max-height: 90vh;
      }

      .variant-icon {
        transform: rotate(45deg);
      }

      .variant-header {
        position: sticky;
        top: 0;
        z-index: 1;
        //order: 2; //desktop, if there are many items
      }
    }

    @media print {
      position: static !important;
      transform: none !important;
    }
  }

  // .variant-wrapper {
  //   overflow: hidden;
  // }

  @media screen and (min-width: 1024px) {
    .variants {
      //overflow-y: auto;
      overflow-x: hidden;
    }

    .variant-container {
      bottom: auto;
      top: 0;
      display: flex;
      flex-direction: column-reverse;
      //transform: translateY(calc(-100% + 3.5rem)) translateX(-50%); //translateX for centering
      transform: translateY(-100%) translateY(3rem) translateX(-50%); //translateX for centering , 2 y-values to support ie11
      transform-origin: center top;
      animation-name: variantDown;
      max-width: 660px;
      overflow-y: hidden !important; //overwrite .is-open
      left: 50%;

      &.is-open {
        transform: translateY(0) translateX(-50%);
      }
    }

    .variant-header-text {
      font-size: 1rem !important;
    }

    //scaling if outside-viewport class is set
    .variant-icon {
      height: 1rem;
      width: 1rem;

      .fa {
        font-size: 1rem;
      }
    }
  }

  @keyframes variantUp {
    0% {
      transform: translateY(100%);
      opacity: 0;
    }

    100% {
      //transform: translateY(calc(100% - 3.5rem));
      transform: translateY(100%) translateY(-3.5rem); //2 y-values to support ie11
      opacity: 1;
    }
  }

  @keyframes variantDown {
    0% {
      transform: translateY(-100%) translateX(-50%);
      opacity: 0;
    }

    100% {
      transform: translateY(-100%) translateY(3rem) translateX(-50%); //translateX for centering , 2 y-values to support ie11
      opacity: 1;
    }
  }

  .variant-header {
    cursor: pointer;
  }

  .isIE11 .variant-header {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
}

.button--back {
  @media screen and (max-width: 768px) {
    position: absolute;
    top: 9.5rem;
    left: -1rem;
    z-index: 2;
    height: auto;
    padding: 0.25rem 0.5rem !important;
    background-color: rgba(255, 255, 255, 0.85) !important;
  }
}

@media screen and (min-width: 1024px) {
  .outside-viewport--standalone {
    .variant-container {
      top: 4.2rem;
      z-index: 29;
    }
  }
}

@media screen and (min-width: 1216px) {
  .input--pieces {
    width: 5em;
  }
}

@media screen and (max-width: 1023px) {
  .slider-body {
    padding-top: 1.5rem;
    padding-bottom: 1rem;
  }

  .variant-backdrop {
    position: fixed;
    z-index: -1; //overlay navigation and underlay cart
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: transparent;
    transition: all 300ms ease-in;
  }

  .outside-viewport {
    .variant-backdrop {
      &.is-open {
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 31;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .hotel-image {
    position: relative;
    left: 50%;
    right: 0;
    width: 100vw;
    transform: translateX(-50%);
    display: block;
    top: 0;
  }

  #hotel-main {
    //padding-top: 0;
    margin-top: -10rem;
  }
}
</style>
